import { Typography } from 'antd'
import FormlessModal from 'components/CIMSModal/FormlessModal'
import { EditFilenameModalState } from './hooks/useEditFilenameModal/types'
import { EditFilenameModalProps } from './types'
import { PropsWithChildren } from 'react'
import CompatibleTemplateItems from './components/CompatibleTemplateItems'
import Warnings from '../Warnings'
import EditTemplateItems from './components/EditTemplateItems'
import Footer from './components/Footer'

function EditFilenameModal<T extends EditFilenameModalState>({
  context,
  name,
  children,
  type,
  ...footerProps
}: PropsWithChildren<EditFilenameModalProps<T>>) {
  const { visible, toggle, state } = context
  return (
    <FormlessModal
      visible={visible}
      cancel={{ fn: () => toggle(null) }}
      ok={false}
      height="tall"
      title={`Edit ${name(state) ?? 'Filename'}`}
      footer={<Footer context={context} {...footerProps} />}
    >
      {children}
      <EditTemplateItems context={context} type={type} />
      <Warnings
        style={{ marginBottom: '1rem' }}
        preface={
          <Typography.Text>
            Use the buttons to add Custom Text or Template Items
          </Typography.Text>
        }
      />
      <CompatibleTemplateItems {...context} />
    </FormlessModal>
  )
}

export default EditFilenameModal
